/**
 * Central SEO config keyed by pathname. Aliases (e.g. /wedding-events) share the same entry.
 * Titles follow: "{Page} | …" with Gujarat/Ahmedabad focus for India search.
 */

const KW =
  "event management company in Gujarat, wedding planner in Ahmedabad, corporate event organizer India, best event planner Gujarat, event management services India, concert organizer Gujarat, production house events India";

const HI =
  "इवेंट मैनेजमेंट कंपनी गुजरात, वेडिंग प्लानर अहमदाबाद, कॉर्पोरेट इवेंट आयोजक, बेस्ट इवेंट प्लानर इंडिया, शादी इवेंट मैनेजमेंट";

const GU =
  "ઇવેન્ટ મેનેજમેન્ટ ગુજરાત, વેડિંગ પ્લાનર અમદાવાદ, ઇવેન્ટ ઓર્ગેનાઇઝર ગુજરાત, બેસ્ટ ઇવેન્ટ પ્લાનર, લગ્ન ઇવેન્ટ મેનેજમેન્ટ";

const GLOBAL_KEYWORDS = `${KW}, ${HI}, ${GU}`;

const DEFAULT = {
  title: "Panthi Events | Best Event Management Company in Gujarat, India",
  description:
    "Panthi Events is a leading event management company in Gujarat, India — wedding planner in Ahmedabad, corporate event organizer, concert production, and end-to-end event management services. Serving Ahmedabad, Gujarat, and clients across India.",
  keywords: GLOBAL_KEYWORDS,
  canonicalPath: "/",
  ogImagePath: "/favicon.png",
  ogType: "website",
  twitterCard: "summary_large_image",
};

function entry(partial) {
  return {
    ...DEFAULT,
    ...partial,
    keywords: partial.keywords || GLOBAL_KEYWORDS,
    ogImagePath: partial.ogImagePath ?? DEFAULT.ogImagePath,
    ogType: partial.ogType ?? DEFAULT.ogType,
    twitterCard: partial.twitterCard ?? DEFAULT.twitterCard,
  };
}

export const ROUTE_SEO = {
  "/": entry({
    title: "Panthi Events | Best Event Management Company in Gujarat, India",
    description:
      "Plan weddings, corporate events, concerts, and productions with Panthi Events — trusted event management services in Ahmedabad, Gujarat, and India. English, Hindi, and Gujarati-friendly planning for memorable celebrations.",
    canonicalPath: "/",
  }),

  "/events": entry({
    title: "Our Events | Best Event Management Company in Gujarat, India",
    description:
      "Explore wedding, corporate, concert, social, and custom events by Panthi Events — event management company in Gujarat with planning and production in Ahmedabad, India.",
    canonicalPath: "/events",
  }),

  "/events/wedding": entry({
    title: "Wedding Events | Best Wedding Planner in Ahmedabad, Gujarat",
    description:
      "Wedding planner in Ahmedabad and Gujarat — destination weddings, sangeet, reception, and full wedding event management. Best event planner Gujarat for elegant, stress-free celebrations across India.",
    canonicalPath: "/wedding-events",
  }),
  "/wedding-events": entry({
    title: "Wedding Events | Best Wedding Planner in Ahmedabad, Gujarat",
    description:
      "Wedding planner in Ahmedabad and Gujarat — destination weddings, sangeet, reception, and full wedding event management. Best event planner Gujarat for elegant, stress-free celebrations across India.",
    canonicalPath: "/wedding-events",
  }),

  "/events/corporate": entry({
    title: "Corporate Events | Corporate Event Organizer in Gujarat & India",
    description:
      "Corporate event organizer for conferences, launches, awards, and team events in Ahmedabad, Gujarat, and India. Professional event management services with AV, staging, and on-ground execution.",
    canonicalPath: "/corporate-events",
  }),
  "/corporate-events": entry({
    title: "Corporate Events | Corporate Event Organizer in Gujarat & India",
    description:
      "Corporate event organizer for conferences, launches, awards, and team events in Ahmedabad, Gujarat, and India. Professional event management services with AV, staging, and on-ground execution.",
    canonicalPath: "/corporate-events",
  }),

  "/events/concert": entry({
    title: "Concerts & Live Shows | Concert Organizer in Gujarat, India",
    description:
      "Concert organizer Gujarat — DJ nights, celebrity shows, college concerts, and production for live events in Ahmedabad and across India. Stage, sound, LED, and crowd management by Panthi Events.",
    canonicalPath: "/concert-events",
  }),
  "/concert-events": entry({
    title: "Concerts & Live Shows | Concert Organizer in Gujarat, India",
    description:
      "Concert organizer Gujarat — DJ nights, celebrity shows, college concerts, and production for live events in Ahmedabad and across India. Stage, sound, LED, and crowd management by Panthi Events.",
    canonicalPath: "/concert-events",
  }),

  "/events/social": entry({
    title: "Social Events | Event Management Services in Ahmedabad, Gujarat",
    description:
      "Social and family celebrations — ring ceremonies, baby showers, anniversaries, and festivals — planned by a top event management company in Gujarat. Serving Ahmedabad and India-wide clients.",
    canonicalPath: "/social-events",
  }),
  "/social-events": entry({
    title: "Social Events | Event Management Services in Ahmedabad, Gujarat",
    description:
      "Social and family celebrations — ring ceremonies, baby showers, anniversaries, and festivals — planned by a top event management company in Gujarat. Serving Ahmedabad and India-wide clients.",
    canonicalPath: "/social-events",
  }),

  "/events/other": entry({
    title: "Other Events | Best Event Planner Gujarat & India",
    description:
      "Fashion shows, sports days, mall activations, charity events, and more — full-service event management in Ahmedabad, Gujarat, and India. Creative production and on-ground coordination.",
    canonicalPath: "/other-events",
  }),
  "/other-events": entry({
    title: "Other Events | Best Event Planner Gujarat & India",
    description:
      "Fashion shows, sports days, mall activations, charity events, and more — full-service event management in Ahmedabad, Gujarat, and India. Creative production and on-ground coordination.",
    canonicalPath: "/other-events",
  }),

  "/events/birthday": entry({
    title: "Birthday Parties | Event Management Company in Gujarat, India",
    description:
      "Kids and milestone birthday parties in Ahmedabad — themes, décor, entertainment, and catering coordination. Part of our event management services India clients trust for stress-free celebrations.",
    canonicalPath: "/birthday-events",
  }),
  "/birthday-events": entry({
    title: "Birthday Parties | Event Management Company in Gujarat, India",
    description:
      "Kids and milestone birthday parties in Ahmedabad — themes, décor, entertainment, and catering coordination. Part of our event management services India clients trust for stress-free celebrations.",
    canonicalPath: "/birthday-events",
  }),

  "/production": entry({
    title: "Event Production | Production House Events India & Gujarat",
    description:
      "Production house events India — stage, lighting, LED, sound, catering, artist management, and technical support for weddings, corporates, and concerts in Ahmedabad, Gujarat.",
    canonicalPath: "/production",
  }),

  "/production/decor-atelier": entry({
    title: "Decor Atelier | Event Production Gujarat & Ahmedabad",
    description:
      "Premium décor and creative event styling for weddings and corporate events — Panthi Events production team in Ahmedabad, Gujarat, India.",
    canonicalPath: "/production/decor-atelier",
  }),
  "/production/stall-design": entry({
    title: "Stall Design | Exhibition & Event Management Gujarat",
    description:
      "Exhibition stalls and branded setups for trade shows and activations — event management company in Gujarat with design and build support.",
    canonicalPath: "/production/stall-design",
  }),
  "/production/photography": entry({
    title: "Event Photography | Wedding & Corporate Events Ahmedabad",
    description:
      "Professional event photography and coverage for weddings and corporate programs — Ahmedabad, Gujarat, India.",
    canonicalPath: "/production/photography",
  }),
  "/production/photo-booth": entry({
    title: "Photo Booth | Fun Event Services Gujarat",
    description:
      "Photo booth hire for weddings, parties, and corporate events — memorable guest experiences in Ahmedabad and Gujarat.",
    canonicalPath: "/production/photo-booth",
  }),
  "/production/catering": entry({
    title: "Event Catering | Wedding & Corporate Catering Ahmedabad",
    description:
      "Catering coordination for weddings, corporates, and large gatherings — quality food service as part of our event management services India.",
    canonicalPath: "/production/catering",
  }),
  "/production/av-equipments": entry({
    title: "AV Equipment | Sound & Visual Production Gujarat",
    description:
      "Professional sound, LED, and AV for concerts and corporate events — concert organizer Gujarat production support.",
    canonicalPath: "/production/av-equipments",
  }),
  "/production/special-effects": entry({
    title: "Special Effects | Stage Effects for Events India",
    description:
      "Cold pyro, confetti, lasers, and stage effects for concerts and launches — production house events India capabilities.",
    canonicalPath: "/production/special-effects",
  }),
  "/production/artist-management": entry({
    title: "Artist & Celebrity Management | Event Management Gujarat",
    description:
      "Artist and celebrity coordination for concerts and corporate shows — trusted event planner Gujarat team.",
    canonicalPath: "/production/artist-management",
  }),
  "/production/kids-zone": entry({
    title: "Kids Zone | Birthday & Family Events Ahmedabad",
    description:
      "Kids entertainment zones for birthdays and family events — safe, engaging setups in Gujarat, India.",
    canonicalPath: "/production/kids-zone",
  }),
  "/production/invitation-card": entry({
    title: "Invitation Cards | Wedding & Event Stationery Gujarat",
    description:
      "Custom invitation and stationery design for weddings and celebrations — Ahmedabad, Gujarat.",
    canonicalPath: "/production/invitation-card",
  }),

  "/gallery": entry({
    title: "Event Gallery | Panthi Events Ahmedabad, Gujarat",
    description:
      "Browse weddings, corporate events, and productions by Panthi Events — event management company in Gujarat showcasing real work across India.",
    canonicalPath: "/gallery",
  }),

  "/blogs": entry({
    title: "Event Planning Blogs | Tips from Gujarat Event Planners",
    description:
      "Ideas and checklists for weddings, corporate events, and concerts — from an experienced event management team in Ahmedabad, Gujarat, India.",
    canonicalPath: "/blogs",
  }),

  "/reviews": entry({
    title: "Reviews & Testimonials | Panthi Events Gujarat",
    description:
      "Client testimonials for Panthi Events — wedding planner Ahmedabad, corporate events, and concert production across Gujarat and India.",
    canonicalPath: "/reviews",
  }),

  "/contact": entry({
    title: "Contact Us | Book an Event Planner in Ahmedabad, Gujarat",
    description:
      "Contact Panthi Events in Nikol, Ahmedabad — phone, email, and venue visits. Google Business Profile listed; book your wedding, corporate, or concert planning consult.",
    canonicalPath: "/contact",
  }),

  "/event-management-ahmedabad": entry({
    title: "Event Management Company in Ahmedabad | Panthi Events Gujarat",
    description:
      "Hire a trusted event management company in Ahmedabad for weddings, corporates, and concerts. Panthi Events plans and produces events across Gujarat and India with full production support.",
    canonicalPath: "/event-management-ahmedabad",
    ogType: "article",
  }),
  "/wedding-planner-ahmedabad": entry({
    title: "Wedding Planner in Ahmedabad | Panthi Events Gujarat India",
    description:
      "Professional wedding planner in Ahmedabad for mehndi, sangeet, wedding day, and reception. Panthi Events delivers Gujarat-wide wedding planning with décor, production, and guest hospitality.",
    canonicalPath: "/wedding-planner-ahmedabad",
    ogType: "article",
  }),
  "/corporate-event-ahmedabad": entry({
    title: "Corporate Event Management Ahmedabad | Panthi Events Gujarat",
    description:
      "Corporate event organizer for conferences, launches, and awards in Ahmedabad. Panthi Events delivers staging, AV, branding, and delegate management across Gujarat and India.",
    canonicalPath: "/corporate-event-ahmedabad",
    ogType: "article",
  }),
};

export function getSeoForPath(pathname) {
  const found = ROUTE_SEO[pathname];
  if (found) return found;
  return { ...DEFAULT, canonicalPath: pathname || "/" };
}
